export const STATE_NAME = 'notificationSystem';
export const NOTIFY = 'NOTIFICATION_NOTIFY';
export const SET = 'NOTIFICATION_SET';
export const INITIATE_CLOSE = 'NOTIFICATION_REQUEST_CLOSE';
export const CLOSED = 'NOTIFICATION_CLOSED';
